import { HashRouter, Routes, Route } from 'react-router-dom'
import { NotificationProvider } from '@alwindows/shared'
import { ScrollToTop } from '@alwindows/shared/a11y'
import { Layout } from './components/Layout'
import { ShipmentProvider } from './shipment/ShipmentContext'
import { Landing } from './pages/Landing'
import { Cart } from './pages/Cart'
import { Checkout } from './pages/Checkout'

export function App() {
  return (
    <HashRouter>
      {/* Scroll to the top of the app container on route change rather than
          to (0, 0). The plugin is mounted inside the live WP theme; jumping
          past the theme header on every navigation is disorienting. */}
      <ScrollToTop selector=".al-sp" />
      <NotificationProvider>
        <ShipmentProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
            </Routes>
          </Layout>
        </ShipmentProvider>
      </NotificationProvider>
    </HashRouter>
  )
}
